import { Component } from '@angular/core';

import { Compiler } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { register } from 'swiper/element/bundle';
import { UserProvider } from './providers/UserProvider';
import { LanguageService } from './services/language/language.service';
import { RolSectionsService } from './services/rol-sections.service';
import { RolServiceService } from './services/rol/rol-service.service';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private languageService: LanguageService,
    private storage: Storage,
    private _compiler: Compiler,
    private rolSectionsService: RolSectionsService,
    private router: Router,
    private userProvider: UserProvider,
    private rolservice: RolServiceService,

  ) {
    this.initializeApp();
  }

  initializeApp() {
    this._compiler.clearCache();
    this.platform.ready().then(async () => {
      this.setLanguage()
      let user = await this.storage.get('user');
      await this.rolservice.getOdenPermissions()

      if (user) {
        // let userInfo = await this.userProvider.getUser(user.id, true);
        let userInfo = await this.rolservice.getUserPermissions(user.id);

        if (userInfo.errors && userInfo.errors[0] == "Unauthorized") {
          await this.storage.clear();
          window.location.reload();
        }

        let redirected = await this.storage.get('redirected');

        if (userInfo.initial_page_panel && !redirected) {
          let initialSection = this.rolSectionsService.getSection(userInfo.initial_page_panel);
          if (initialSection !== '') {
            this.router.navigateByUrl(initialSection);
            this.storage.set('redirected', true)
          }
        }
      }
      const theme = await this.storage.get('theme');
      if (theme == 'dark') {
        document.documentElement.classList.add('dark')
        document.documentElement.classList.remove('light')
      } else if (theme == 'light') {
        document.documentElement.classList.add('light')
        document.documentElement.classList.remove('dark')
      }
      else {
        document.documentElement.classList.add('dark')
        document.documentElement.classList.remove('light')
        this.storage.set('theme', 'dark')
      }
    });
  }

  setLanguage() {
    this.storage.get('language').then((language) => {
      if (language) {
        this.languageService.change(language)
      }
      else {
        this.languageService.change('es-MX')
      }
    });
  }
}
